
import { Property, AgentProfile } from './types';

export const INITIAL_AGENTS: AgentProfile[] = [
  {
    id: 'sterling-prime',
    name: "Julian Sterling",
    business_name: "Sterling Prime Real Estate",
    bio: "Curating the finest luxury residential and commercial portfolios in the Metropolitan area.",
    avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400&h=400",
    location: "New York, USA",
    phone: "+1 (555) 0123-4567",
    whatsapp: "155501234567",
    is_verified: true,
    verification_status: 'verified',
    plan: 'Pro'
  },
  {
    id: 'luxe-living',
    name: "Sarah Jenkins",
    business_name: "Luxe Living Group",
    bio: "Expert in high-end beachfront properties and modern urban lofts.",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400&h=400",
    location: "Miami, FL",
    phone: "+1 (555) 999-8888",
    whatsapp: "15559998888",
    is_verified: false,
    verification_status: 'unverified',
    plan: 'Free'
  }
];

export const MOCK_PROPERTIES: Property[] = [
  // Fixed missing required properties: currency, is_negotiable, locality, category, market_status, is_furnished, is_serviced
  {
    id: '1',
    agent_id: 'sterling-prime',
    title: 'Minimalist Glass Mansion',
    price: 4500000,
    currency: 'USD',
    is_negotiable: true,
    location: 'Beverly Hills, CA',
    locality: 'Beverly Hills',
    type: 'Villa',
    category: 'Sale',
    market_status: 'Available',
    bedrooms: 6,
    bathrooms: 8,
    area: 8500,
    is_furnished: true,
    is_serviced: true,
    description: 'A contemporary masterpiece featuring floor-to-ceiling glass walls.',
    images: ['https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&q=80&w=800&h=800'],
    status: 'Available',
    created_at: Date.now() - 86400000,
    features: ['Infinity Pool', 'Home Cinema']
  },
  // Fixed missing required properties: currency, is_negotiable, locality, category, market_status, is_furnished, is_serviced
  {
    id: '2',
    agent_id: 'luxe-living',
    title: 'Oceanfront Penthouse',
    price: 3200000,
    currency: 'USD',
    is_negotiable: false,
    location: 'Miami Beach, FL',
    locality: 'Miami Beach',
    type: 'Apartment',
    category: 'Sale',
    market_status: 'Available',
    bedrooms: 3,
    bathrooms: 3,
    area: 2800,
    is_furnished: true,
    is_serviced: true,
    description: 'Stunning 360-degree views of the Atlantic Ocean.',
    images: ['https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80&w=800&h=800'],
    status: 'Available',
    created_at: Date.now() - 172800000,
    features: ['Private Elevator', 'Wine Cellar']
  },
  // Fixed missing required properties: currency, is_negotiable, locality, category, market_status, is_furnished, is_serviced
  {
    id: '3',
    agent_id: 'sterling-prime',
    title: 'Modern Urban Loft',
    price: 1200000,
    currency: 'USD',
    is_negotiable: true,
    location: 'Brooklyn, NY',
    locality: 'Brooklyn',
    type: 'Apartment',
    category: 'Rent',
    market_status: 'Available',
    bedrooms: 2,
    bathrooms: 2,
    area: 1500,
    is_furnished: true,
    is_serviced: false,
    description: 'Exposed brick walls and industrial finishes in the heart of Dumbo.',
    images: ['https://images.unsplash.com/photo-1560448204-61dc36dc98c8?auto=format&fit=crop&q=80&w=800&h=800'],
    status: 'Available',
    created_at: Date.now() - 259200000,
    features: ['High Ceilings', 'Smart Home']
  }
];